import { useEffect } from "react"
import { graphql } from "gatsby"
import { StyledHeaderSection, StyledJobsSection, StyledRow, StyledColumn } from "./styled-apply"
import RichText from "@components/rich-text/renderer"
import { findById } from "@utils/contentful"
import reducePageContent from "@utils/reducePageContent"

const JobApply = ({ data }) => {
  const page = data.page
  const pageContent = reducePageContent(page)

  const hero = pageContent["Sh65qN3drx5TJBWyjPRa4"]
  const heroContentText = findById(hero, "65IbGGWENp9Me3rfP6BSpH")

  useEffect(() => {
    var script = document.createElement("script")
    script.onload = function () {
      // Apply timeout to wait for script execution in chromium based browsers
      setTimeout(() => {
        if (!document.getElementById("grnhse_iframe")) {
          window.Grnhse.Iframe.load()
        }
      }, 100)
    }
    script.src = "https://app.greenhouse.io/embed/job_board/js?for=fastly&autoload=false"

    document.head.appendChild(script)
  }, [])

  return (
    <>
      <StyledHeaderSection>
        <StyledRow>
          <StyledColumn>
            <RichText
              body={heroContentText.rtContent}
              key={heroContentText.contentful_id}
              mikan={heroContentText.mikan}
            />
          </StyledColumn>
        </StyledRow>
      </StyledHeaderSection>
      <StyledJobsSection>
        <div id="grnhse_app" className="career-iframe"></div>
      </StyledJobsSection>
    </>
  )
}

export default JobApply

export const query = graphql`
  query {
    page: contentfulPage(contentful_id: { eq: "24YTS3m2LkAs6YSY0hoD5n" }) {
      ...Page
    }
  }
`

export { Head } from "@components/Head/Head"
